import {User, UserInterface} from "./User";
import {Dictionary} from "./Dictionary";
import {DictionaryInterface} from "./DictionaryInterface";

export class XHR {
    private dictionary: Dictionary = new Dictionary();
    private user: UserInterface = new User();
    private _response: Response | null = null;
    private _error: any = null;
    private static _base: string;

    public async fetch(input: RequestInfo | URL, init?: RequestInit | any, extra?: object): Promise<Response> {
        this._error = null;
        this._response = null;

        if (typeof input === 'string') {
            input = XHR._base + input;
        }

        if (init === undefined || init === null || typeof init === 'object') {
            init = this.createRequestInit(init, typeof extra === 'object' ? extra : {});
        }

        try {
            const response = await fetch(input, init);
            this._response = response;
            const result = await response.json();

            if (typeof result.checkDictionaryVersion !== 'undefined' &&
                this.dictionary.dictionaryVersion !== result.checkDictionaryVersion) {
                await this.fetchDictionary();
            }

            if (this.user.valid() && this.user.needRenew(result.checkUserVersion)) {
                this.fetch('/renew').then((data: any) => {
                    if (data?.user && data?.token) {
                        this.user.set(data.user, data.token);
                    }
                }).catch(error => {
                    console.error(error);
                });
            }

            return result;
        } catch (error) {
            this._error = error;
            throw error;
        }
    }

    get response(): Response | null {
        return this._response;
    }

    get error(): any {
        return this._error;
    }

    public isUnauthorized(): boolean {
        return this._response?.status === 401;
    }

    public isForbidden(): boolean {
        return this._response?.status === 403;
    }

    public getResponseStatus(): number | null {
        return this._response?.status || null;
    }

    get base(): string {
        return XHR._base;
    }

    set base(value: string) {
        XHR._base = value;
    }

    private createRequestInit(data: any, extra: object | any) {
        let headers: object | any = {
            "X-Requested-With": "XMLHttpRequest",
            "Authorization": "Bearer " + this.user.getToken()
        };

        if (!(data instanceof FormData) && data) {
            data = JSON.stringify(data);
            headers["Content-Type"] = "application/json; charset=UTF-8";
        }

        if (data === undefined || data === null) {
            return {
                method: typeof extra.method !== 'string' ? "POST" : extra.method,
                headers: headers
            };
        }

        return {
            method: typeof extra.method !== 'string' ? "POST" : extra.method,
            headers: headers,
            body: data
        };
    }

    public async fetchDictionary(): Promise<DictionaryInterface> {
        const data: DictionaryInterface | any = await this.fetch('/dictionary', {
            navigatorLanguage: navigator.language,
            navigatorLanguages: navigator.languages,
            dictionaryVersion: this.dictionary.dictionaryVersion
        });

        if (typeof data?.dictionaryVersion === 'string') {
            this.dictionary.setUp(data);
        }

        return data;
    }
}
